import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
    backgroundColor: 'transparent',
  },
  content: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
  },
}));

export default useStyles;
